module.exports = __webpack_public_path__ + "ff1c357750f390e249c91b2e0ec33879.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/informations/aboutUs/Michael.png
// module id = 1484
// module chunks = 0